import { ChevronRight, Compass } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Badge, PageHeader } from '../../components/ui';
import paulaAvatar from '../../assets/paula.png';

export default function IntakePickerScreen() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col min-h-screen p-6 screen-enter">
      <PageHeader title="" onBack={() => navigate('/citizen')} />
      <div className="flex-1 flex flex-col justify-center space-y-5">
        <div className="space-y-2">
          <h1 className="text-3xl font-extrabold tracking-tight">How would you like to set up?</h1>
          <p className="text-[15px] text-[color:var(--muted-foreground)]">
            Either way takes about a minute. You can change anything later.
          </p>
        </div>

        <button
          onClick={() => navigate('/citizen/intake/quick')}
          className="rounded-2xl p-5 text-left hover-elevate active-elevate-2 border"
          style={{ background: 'var(--card)', borderColor: 'var(--border)' }}
        >
          <div className="flex items-start gap-4">
            <div
              className="w-12 h-12 rounded-full flex items-center justify-center"
              style={{ background: 'var(--accent)', color: 'var(--primary)' }}
            >
              <Compass className="w-6 h-6" />
            </div>
            <div className="flex-1">
              <div className="flex items-center gap-2">
                <h3 className="text-lg font-bold">Quick setup</h3>
                <Badge variant="gold">~ 1 min</Badge>
              </div>
              <p className="text-sm text-[color:var(--muted-foreground)] mt-1">
                Four screens. ZIP, priorities, party, affiliation. Done.
              </p>
            </div>
            <ChevronRight className="w-5 h-5 text-[color:var(--muted-foreground)] mt-2" />
          </div>
        </button>

        <button
          onClick={() => navigate('/citizen/intake/convo')}
          className="rounded-2xl p-5 text-left hover-elevate active-elevate-2 border"
          style={{ background: 'var(--card)', borderColor: 'var(--border)' }}
        >
          <div className="flex items-start gap-4">
            <div className="w-14 h-14 rounded-full overflow-hidden shrink-0 ring-2" style={{ background: 'var(--hero-deep)' }}>
              <img src={paulaAvatar} alt="Paula" className="w-full h-full object-cover" />
            </div>
            <div className="flex-1">
              <div className="flex items-center gap-2">
                <h3 className="text-lg font-bold">Chat with Paula</h3>
                <Badge variant="accent">Recommended</Badge>
              </div>
              <p className="text-sm text-[color:var(--muted-foreground)] mt-1">
                Conversational setup. Feels less like a form.
              </p>
            </div>
            <ChevronRight className="w-5 h-5 text-[color:var(--muted-foreground)] mt-2" />
          </div>
        </button>
      </div>
    </div>
  );
}
